import React from 'react'
import {
  CloseIcon,
  IcoMoon,
} from '@usap/uicomponents'
import {
  WrapperCloseButton,
  TitleStyled,
  TextSubtitleStyled,
  TextStyled,
  TitleHowTostyled,
  LayerBoxStyled,
} from './InstallationQuotes.css'

const InstallationQuotesPopupContent = ({ onCloseCallback }) => (
  <LayerBoxStyled
    id="installation-quotes-popup"
    pad="large"
    responsive
  >
    <WrapperCloseButton>
      <IcoMoon size="21px" icon={CloseIcon} onClick={onCloseCallback} />
    </WrapperCloseButton>
    <TitleStyled
      color="dark-2"
      size="24px"
      weight="bold"
      label="Find the Right Part and the Right Shop"
    />
    <TextSubtitleStyled size="16px">
      Helping you save time doesn’t stop at connecting you with the
      parts you need. We’re proud to work with independent shops and
      mechanics who are ready to help in your area.
    </TextSubtitleStyled>
    <TitleHowTostyled
      weight="bold"
      size="20px"
      color="dark-2"
      label="How to Sign Up"
    />
    <TextStyled size="16px">
      <strong>Step 1:</strong>
      {' '}
      Select “I want installation quotes at no cost”
      during checkout.
    </TextStyled>
    <TextStyled size="16px">
      <strong>Step 2:</strong>
      {' '}
      Our dedicated team will gather quotes
      from certified shops in your area and set up an appointment with
      the mechanic of your choice.
    </TextStyled>
    <TextStyled size="16px">
      <strong>Step 3:</strong>
      {' '}
      Show up at your scheduled time with the part you ordered. That’s it!
    </TextStyled>
  </LayerBoxStyled>
)

export default InstallationQuotesPopupContent
